import { Box, CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useSelector } from 'react-redux';

import MaintenancePage from 'components/pages/MaintenancePage';
import NotificationDialog from 'components/elements/NotificationDialog';
import NavigationScroll from 'components/layout/NavigationScroll';
import Loader from 'components/ui/Loader';
import Snackbar from 'components/ui/Snackbar';
import useAppInit from 'hooks/useAppInit';
import useMaintenanceGate from 'hooks/useMaintenanceGate';
import Routes from 'routes';
import themes from 'themes';

const AppShell = () => {
  const customization = useSelector((state) => state.customization);

  useAppInit();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          <Routes />
          <Snackbar />
          <NotificationDialog />
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

const MaintenanceLoader = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
    <Loader size={48} />
  </Box>
);

const App = () => {
  const { loading, isMaintenanceMode, title, message } = useMaintenanceGate('portal-fe');

  if (loading) {
    return <MaintenanceLoader />;
  }

  if (isMaintenanceMode) {
    return <MaintenancePage title={title} message={message} />;
  }

  return <AppShell />;
};

export default App;
